<template>
  <div justify="center" class="dialogo">
    
    <v-btn
          
          small
          text
          icon
          fab
          @click="onUserSave"
          title="Blog de notas"
        >
          <v-icon medium dark color="blue">note </v-icon>
        </v-btn>
    <v-dialog v-model="dialog">
      <v-card class="mx-auto my-12" max-width="574">
        <v-card-title style="padding-bottom: 0px">Acciones</v-card-title>
        <hr>
        <v-card-text>
          <v-flex class="xs12">
            <v-text-field
              label="Acción"
              v-model="model"
            ></v-text-field>
            <v-btn
                  color="#00aeef"
                  small
                  @click="accionSave"
                  title="Guardar"
                  style="color: #fff; float: right"
                >
                  Guardar
                </v-btn>
          </v-flex>
          </v-card-text>
          <v-card-text>
            <v-flex class="xs12">
              <v-flex class="my-4 subtitle-1"><h5>Listado de acciones</h5></v-flex>

              <div>
                <table width="574px">
                  <tr>
                    <th class="text-xs-left cut-text">Acción</th>
                    <th class="text-xs-left cut-text">Fecha</th>
                  </tr>
                  <tr v-for="item in accion" :key="item.fecha">
                    <td style="width: 55%">{{ item.accion }}</td>
                    <td>{{ item.fecha }}</td>
                  </tr>
                </table>
              </div>
            </v-flex>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>
        <v-card-actions>
        <v-flex class="xs12">
          <div style="float: right">
              <v-btn color="default" text small @click="onUserSave" style="float: right"> Salir </v-btn>
          </div>
        </v-flex>
            </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>
<script>
import service from "@/services/EcommerceServices";
export default {
  props: {
    id: {
      type: Number,
    },
    accion: [],
  },
  computed: {},
  data() {
    return {
      dialog: false,
      model: "",
      load: false,
      errors: [],
    };
  },
  methods: {
    accionSave() {
      if (this.model != "" && this.model != undefined) {
        this.load = true;
        const serv= service.actionEnviarAccion(this.id, this.model)
        
        serv.then(() => {
          this.load = false;
          this.dialog = false;
          this.$emit("filtrar");
        });
      } else {
      }
    },
    onUserSave() {
      this.dialog = !this.dialog;
    },
  },
};
</script>
<style scope>

</style>